var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import { useTheme, Drawer as MuiDrawer, } from '@mui/material';
import { Close } from '@mui/icons-material';
import { IconButton } from '../icon-button';
import { DEFAULT_DRAWER_WIDTH } from '../../theme';
var HEADER_HEIGHT = 108;
export default function Drawer(_a) {
    var _b, _c;
    var children = _a.children, open = _a.open, toggleDrawer = _a.toggleDrawer, Header = _a.Header, drawerWidth = _a.drawerWidth, props = __rest(_a, ["children", "open", "toggleDrawer", "Header", "drawerWidth"]);
    var _d = useState(0), scrollTop = _d[0], setScrollTop = _d[1];
    var _e = useState(HEADER_HEIGHT), headerHeight = _e[0], setHeaderHeight = _e[1];
    var theme = useTheme();
    var isToporBottomAnchor = props.anchor === 'top' || props.anchor === 'bottom';
    var windowWidth = window.innerWidth;
    var paperCallbackRef = function (node) {
        var scrollElement = node;
        if (scrollElement) {
            scrollElement.onscroll = function () {
                setScrollTop(scrollElement.scrollTop);
            };
        }
    };
    var headerCallbackRef = useCallback(function (node) {
        var _a;
        if (node) {
            var height = (_a = node.offsetHeight) !== null && _a !== void 0 ? _a : HEADER_HEIGHT;
            setHeaderHeight(height);
        }
    }, []);
    return (_jsx(MuiDrawer, __assign({ PaperProps: {
            ref: paperCallbackRef,
            sx: (_b = {
                    overflowY: 'overlay',
                    width: isToporBottomAnchor ? windowWidth : 'initial'
                },
                _b[theme.breakpoints.down('tablet')] = {
                    width: windowWidth,
                },
                _b),
        }, open: open, onClose: function () { return toggleDrawer(); } }, props, { children: _jsxs(Box, __assign({ sx: (_c = {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    width: isToporBottomAnchor
                        ? windowWidth
                        : drawerWidth || DEFAULT_DRAWER_WIDTH
                },
                _c[theme.breakpoints.down('tablet')] = {
                    width: windowWidth,
                },
                _c) }, { children: [_jsxs(Box, __assign({ ref: headerCallbackRef, sx: {
                        display: 'flex',
                        boxShadow: scrollTop > 0 ? 1 : 0,
                        position: 'fixed',
                        width: 'inherit',
                        minHeight: Header ? "".concat(headerHeight, "px") : 'initial',
                        zIndex: 2,
                        backgroundColor: theme.palette.common.white,
                    } }, { children: [Header && (_jsx(Box, __assign({ sx: {
                                position: 'relative',
                                p: 3,
                                pb: 0,
                                display: 'flex',
                                width: '100%',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            } }, { children: Header }))), _jsx(IconButton, { sx: {
                                position: 'absolute',
                                top: '16px',
                                right: '16px',
                                zIndex: 3,
                                color: theme.palette.text.secondary,
                            }, onClick: function () { return toggleDrawer(); }, icon: _jsx(Close, {}), "aria-label": "Close" })] })), _jsx(Box, __assign({ role: "list", sx: {
                        mt: Header ? "".concat(headerHeight, "px") : 'initial',
                        flex: 1,
                        position: 'relative',
                    } }, { children: children }))] })) })));
}
